import { useNavigate } from 'react-router';
import { Globe, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * IntelExplorerLaunchPanel
 *
 * Button to navigate to /intelligence/explorer
 */
export function IntelExplorerLaunchPanel(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <div className="space-y-2">
      <div className="text-[11px] font-semibold uppercase tracking-wider text-text-tertiary">
        3D Explorer
      </div>
      <Button
        size="sm"
        className="w-full justify-between"
        onClick={() => {
          navigate('/intelligence/explorer');
        }}
      >
        <div className="flex items-center gap-2">
          <Globe className="h-4 w-4" />
          <span>Open Explorer</span>
        </div>
        <ChevronRight className="h-4 w-4" />
      </Button>
      <p className="text-[10px] text-text-tertiary">
        Explore projects on Fibonacci sphere: shared patterns as orbiting nodes.
      </p>
    </div>
  );
}
